module.exports = __webpack_public_path__ + "static/img/avatar-s-2.93c7a17a.png";